export default new class {

  constructor () {
    this.menuFieldBaseStructure = {
      Field:             {
        required: true,
        default:  ''
      },
      DictionaryKeyCode: {
        required: true,
        default:  ''
      },
      WhereCondition:    {
        required: false,
        default:  ''
      }
    }
  }

  /**
   *
   * @param menuField
   * @returns {*}
   */
  getParams (menuField) {
    this._checkMenuFieldStructure(menuField)

    let target = this._getTarget(menuField)

    if (!target) {
      return '#'
    }

    return { name: target[0], params: target[1] }
  }

  /**
   *
   * @param menuField
   * @private
   */
  _checkMenuFieldStructure (menuField) {
    Object
      .keys(this.menuFieldBaseStructure)
      .map(key => {
        if (!menuField.hasOwnProperty(key) &&
          this.menuFieldBaseStructure[key].required) {
          console.error(
            '"menuField" does not have required property (' + key + ')!')
        }
      })
  }

  /**
   *
   * @private
   */
  _getTarget (menuField) {
    switch (menuField.FieldType) {
      case 'ENUENTFORM':
        return [
          'PageDynamicGrid',
          this._getGridPageParam(menuField)
        ]
      case 'ENUPAGE':
        return [
          'Dashboard',
          {}
        ]
      case 'ENUWIDGET':
        return [
          menuField.Interpretation.toLowerCase(),
          this._getGridPageParam(menuField)
        ]
    }

    return null
  }

  /**
   *
   * @param menuField
   * @returns {{page: *, idStructure: *, menuField: *}}
   * @private
   */
  _getGridPageParam (menuField) {
    return {

      // parametry do url
      page:        menuField.Field,
      idStructure: menuField.idtEntityStructureFrom,

      // props parametr nesouci vsechny data z api
      menuField: menuField
    }
  }

}
